import { createVariants } from 'shared-ui/lib'

export const sectionCardClasses = createVariants({
  base: 'p-6 rounded-xl bg-white overflow-x-auto'
})

export const subSectionCardClasses = createVariants({
  base: 'rounded-lg bg-gray-100 flex flex-col gap-1 p-2 w-full flex-1'
})
